import type { CheckoutFormFieldKey } from "@app/types/checkout-form-types";

export const FORM_FIELD_KEY = {
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  GENDER: "gender",
  PASSENGER_QUESTIONS_GENDER: "passenger_questions.gender",
  DISCOUNT: "discount",
  DOB: "dob",
  OPERATOR_LOYALTY_PROGRAM: "operator_loyalty_program",
  PASSENGER_QUESTIONS_NUMBER_OF_BAGS: "passenger_questions.number_of_bags",
  PASSENGER_QUESTIONS_NUMBER_OF_BIKES: "passenger_questions.number_of_bikes",
  PASSENGER_QUESTIONS_HOTEL: "passenger_questions.hotel",
  PASSENGER_QUESTIONS_DOB: "passenger_questions.dob",
  MARITAL_STATUS: "marital_status",
  NATIONALITY: "nationality",
  OUTBOUND_BREAKFAST: "outbound_breakfast",
  OUTBOUND_LUNCH: "outbound_lunch",
  OUTBOUND_SUPPER: "outbound_supper",
  OUTBOUND_SNACK: "outbound_snack",
  RETURN_BREAKFAST: "return_breakfast",
  RETURN_LUNCH: "return_lunch",
  RETURN_SUPPER: "return_supper",
  RETURN_SNACK: "return_snack",
  ID_TYPE: "id_type",
  ID_EXPIRY_DATE: "id_expiry_date",
  GOVERNMENT_ID: "government_id",
  PROFESSION: "profession",
  SEAT_SELECTION: "seat_selection",
  CARD_NUMBER: "card_number",
  CARD_EXPIRY: "card_expiry",
  CARD_CARDHOLDER: "card_cardholder",
  CARD_CVC: "card_cvc",
  ADDRESS: "address",
  ADDRESS_COMPLEMENT: "address_complement",
  CITY: "city",
  COUNTRY: "country",
  STATE: "state",
  ZIP: "zip",
  ID_NUMBER: "id_number",
  PASSWORD: "password",
  PASSWORD_CONFIRM: "password_confirm",
  EMAIL_OPT_IN: "email_opt_in",
  INSTALLMENTS: "installments",
  INSTALLMENTS_PLANS: "installments_plans",
  RESIDENCY: "residency",
  CUIL_ARG: "cuil_arg",
  SEND_TICKETS_TO_WHATSAPP: "send_tickets_to_whatsapp"
} satisfies Record<string, CheckoutFormFieldKey>;
